import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardCredit from "../../components/Credit/Auth/DashboardCredit";
import { ezsServiceIds, idfServiceIds } from "../../config/UserServicesList";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as DashboardActions from "../../store/dashboardService/actions";
import * as CreditActions from "../../store/credit/actions";
import { useAreServicesActive, useAreServicesAndFeatureActive, useCheckAnyServiceActive } from "../../util/CommonServices";
import { DialogComponent } from "../common/DialogComponent";
import ErrorBoundary from "../common/ErrorBoundary";
import CancellationContinuationDialog from "../Dialogs/CancellationContinuationDialog";
import FamilyProtectionDialog from "../Dialogs/FamilyProtectionDialog";
import DashboardVideoDialog from "../Dialogs/DashboardVideoDialog";
import SubscriptionChangeDialog from "../Dialogs/protectionPlan/SubscriptionChangeDialog";
import DownloadApp from "./DownloadApp";
import DedicatedResolutionSpecialistCard from "../RightSideCard/DedicatedResolutionSpecialistCard";
import FeedbackCard from "../RightSideCard/FeedbackCard";
import LostWalletAssistance from "../RightSideCard/LostWalletAssistance";
import RequestBreachCodes from "../RightSideCard/RequestBreachCodes";
import { BusinessCreditReportStatePII } from "../../store/businessCreditReportService/types";
import DashboardAlerts from "./DashboardAlerts";
import EZSProtectionPlanDialogContainer from "../../components/ManageAccount/ProtectionPlan/ezs/EZSProtectionPlanDialogContainer";
import DashboardMessages from "./DashboardMessages";
import DashboardService from "./DashboardService";
import EducationArticle from "./EducationArticle";
import LetsGetStarted from "./LetsGetStarted";
import * as services from "../../store/service";
import BCreditScoreTracker from "../../components/Credit/BusinessCreditScore/BCreditScoreTracker";
import BCreditRiskTracker from "../../components/Credit/BusinessCreditScore/BCreditRiskTracker";
import BusinessCredit from "../../components/Credit/BusinessCreditScore/BusinessCredit";
import BreachIQCard from "./BreachIQCard";
import { breachServiceActive } from "../../util/CommonBreach";
import * as BreachActions from "../../store/breachService/actions";
import { useTranslation } from "react-i18next";
import RenewFamilyMemberDialog from "../Dialogs/RenewFamilyMemberDialog";
import { Link, useHistory } from "react-router-dom";
import LogoContainer from "../common/LogoContainer";
import { RECEIVE_CONFIGURATION } from "../../store/configurationService/types";
import CMServiceAuth from "./CMServiceAuth";
import CreditLockCard from "../RightSideCard/CreditLockCard";
import ProfileCompleteDialog from "../Dialogs/ProfileCompleteDialog";
import TUAuthentication from "../Credit/Auth/TUAuthentication";
import WrittenInstructionDialog from "./WrittenInstructionDialog";
import MigratedUserPurchasePlan from "../Dialogs/protectionPlan/MigratedUserPurchasePlan";
import * as MyAccountActions from "../../store/myAccount/actions";
import * as BillingStatusActions from "../../store/BillingStatusService/actions";
import * as FamilyServiceAction from "../../store/familyService/actions";
import * as httpClient from "../../util/httpClient";

const Dashboard = (props: any) => {
    const history = useHistory();
    const [businessCreditReportStatePII, setBusinessCreditReportStatePII] = useState({} as BusinessCreditReportStatePII);
    const changedServices = useSelector((state: ApplicationState) => {
        return state.checkContractChangeState;
    });
    const dispatch = useDispatch();
    const requestCreditAuth = () => dispatch(CreditActions.actionCreators.requestValidateAuthentication());
    const requestCreditHistory = () => dispatch(CreditActions.actionCreators.requestCreditHistory(false));
    const requesPartnerConfig = () => dispatch(ConfigurationActions.actionCreators.requestPartnerConfig());
    const [isFamilyProtectionDialogVisible, setFamilyProtectionDialogIsVisible] = useState(false);
    const [isRenewFamilyMemberDialogVisible, setRenewFamilyMemberDialogIsVisible] = useState(false);

    let latestUserDashboardStatus = useSelector((state: ApplicationState) =>
        state.dashboardServiceState && state.dashboardServiceState.userDashboardstatus ? state.dashboardServiceState.userDashboardstatus : ""
    );
    const [subscriptionTypeChange, setSubscriptionTypeChange] = useState(false);
    const [subscriptionChangeDialog, setSubscriptionChangeDialog] = useState(false);
    const [showDashboardVideoDialog, setShowDashboardVideoDialog] = useState(false);
    const [showCancelletionContinuation, setShowCancelletionContinuation] = useState(false);
    const [upgradeConfirmationDialog, setUpgradeConfirmationDialog] = useState(false);
    const [showProfileCompleteDialog, setShowProfileCompleteDialog] = useState(false);
    const [showWrittenInstructionDialog, setShowWrittenInstructionDialog] = useState(false);
    const [showUltraSecureInstructionsDialog, setShowUltraSecureInstructionsDialog] = useState(false);

    const [showPurchasePopup, setShowPurchasePopup] = useState(false);
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const activePackageEnrollment = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activePackageInfo ? state.loggedInUser.activePackageInfo : null
    );
    const isActiveUserServicesLoaded = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.isLoadedActiveUserServices);
    const refreshingCSIDUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.refreshingCSIDUserStatus ? state.csidUserStatusState.refreshingCSIDUserStatus : false
    );
    const hasPurchaseCreditReport = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.hasPurchaseCreditReport);
    const hasOneTimeScore = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeScore);
    const packageData = useSelector((state: ApplicationState) => (state.packageUpgradeState ? state.packageUpgradeState.packageInformationData : {}));
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const [payAsYouGoPkgDetails, setPayAsYouGoPkgDetails] = useState();
    const [addedFamilyMembers, setAddedFamilyMembers] = useState([]);
    const [removedFamilyMembers, setRemovedFamilyMembers]: any = useState([]);
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    const [writtenInfoTime, setTime] = useState("");
    const renderInWebView: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInWebView
            ? state.configurationState.configuration.partnerConfig.renderInWebView
            : false
    );
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const appStateConfiguration = useSelector((state: ApplicationState) => state.configurationState && state.configurationState.configuration);
    const isPartnerModeSSO = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerModes &&
            state.configurationState.configuration.partnerConfig.partnerModes?.includes("PartnerMode.LoginOption.SSO")
        ) {
            return true;
        }
        return false;
    });
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
            ? state.loggedInUser.userServiceDetails.userServices
            : []
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const emailAddress = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.EmailAddress ? state.loggedInUser.userInfo.EmailAddress : ""
    );
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );

    const isEsetId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2652
                ? true
                : false
            : false
    );

    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );

    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const isIDFRevwireUser = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo?.isIDFRevwireUser
            ? state.myAccountServiceState._unifiedAccountInfo.isIDFRevwireUser === true
                ? true
                : false
            : false
    );

    const isLegacyIDFWrittenRequired = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo?.isLegacyIDFWrittenAccepted
            ? state.myAccountServiceState._unifiedAccountInfo.isLegacyIDFWrittenAccepted?.toLowerCase() === 'required'
                ? true
                : false
            : false
    );

    const creditEnrollmentDetails = useSelector((state: ApplicationState) => {
        if (state.creditEnrollmentDetailsState.creditEnrollmentDetails != null) {
            return state.creditEnrollmentDetailsState.creditEnrollmentDetails;
        }
        return {};
    });

    const isCreditEnrollmentDetailsLoaded = useSelector((state: ApplicationState) =>
        state.creditEnrollmentDetailsState && state.creditEnrollmentDetailsState.isCreditEnrollmentDetailsLoaded ?
            state.creditEnrollmentDetailsState.isCreditEnrollmentDetailsLoaded : false
    );

    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    const openAddFamilyProtectionDialog = (): any => {
        setFamilyProtectionDialogIsVisible(true);
    };

    const closeFamilyProtectionDialog = (): any => {
        setFamilyProtectionDialogIsVisible(false);
    };
    const closeWrittenInstructionDialog = (): any => {
        setShowWrittenInstructionDialog(false);
        let writtenInfoTime = new Date().toISOString().replace(/T/, " ").replace(/\..+/, "").toString();
        setTime(writtenInfoTime.toString());
        setShowPurchasePopup(true);
    };

    const closeUltrasecureWrittenInstructionDialog = () => {
        services.postLegacyWrittenInstructionTimestamp().then((response) => {
            if (response && response?.isSuccess === true && response?.hasError === false) {
                services.GetAccountInformation().then((data: any) => {
                    if (data["_unifiedAccountInfo"] && data["_unifiedAccountInfo"]._personalAccountInformation.primaryEmail) {
                        dispatch(MyAccountActions.actionCreators.getAccountInformation(true, data));
                    }
                });
            }
            setShowUltraSecureInstructionsDialog(false);
        });
    }

    const handlePackageUpgradeDialog = (value: string): any => {
        if (value === "show") {
            //setUpgradeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowPurchasePopup(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowPurchasePopup(false);
        } else if (value === "submitted") {
            document.body.classList.remove("no_scroll");
        }
    };
    const closeRenewFamilyMemberDialog = (showUpgradePopup: boolean, removedFamilyMembers: any, addedFamilyMembers: any): any => {
        setRenewFamilyMemberDialogIsVisible(false);
        if (showUpgradePopup) {
            setUpgradeConfirmationDialog(true);
            setAddedFamilyMembers(addedFamilyMembers);
            setRemovedFamilyMembers(removedFamilyMembers);
        } else {
            setShowCancelletionContinuation(true);
        }
    };

    const openRenewFamilyMemberDialog = (): any => {
        setRenewFamilyMemberDialogIsVisible(true);
    };

    const openDashboardVideoDialog = (): any => {
        setShowDashboardVideoDialog(true);
    };

    const closeDashboardVideoDialog = (): any => {
        setShowDashboardVideoDialog(false);
    };

    const closeProfileCompleteDialog = (): any => {
        setShowProfileCompleteDialog(false);
    };
    const handleSubscriptionChangeDialog = (value: string): any => {
        if (value === "show") {
            setSubscriptionChangeDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setSubscriptionChangeDialog(false);
        }
    };

    const handleCancellationContinuationDialog = (value: string): any => {
        if (value === "show") {
            setShowCancelletionContinuation(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowCancelletionContinuation(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowCancelletionContinuation(false);
        }
    };

    const ids = [
        idfServiceIds.lostWalletAssistance,
        ezsServiceIds.idRestorationPro,
        ezsServiceIds.idRestorationProInd,
        ezsServiceIds.idDRestorationProWith1mInsurance,
        ezsServiceIds.idRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationPro,
        ezsServiceIds.familyIdRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationProWith1MInsurance,
        ezsServiceIds.businessIdRestorationPro,
        ezsServiceIds.businessIdRestorationClassic,
    ];
    const isLostWallet = useAreServicesAndFeatureActive(ids, ["Product.Provide.VALUTFeature"]);

    const isRequestBreachCodesVisible = () => {
        if (userServices.length) {
            let employeeService = userServices.find((item) => item.serviceCode === "SVC-DISC-BREACH-CODE");
            if (employeeService && Object.keys(employeeService).length) {
                return true;
            }
        }
        return false;
    };

    const creditScoreAndTrackerServiceList = [
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,

        idfServiceIds.creditScoreTracker,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
    ];

    const isCreditScoreOrTrackerActive = useAreServicesActive(creditScoreAndTrackerServiceList) || (hasPurchaseCreditReport && hasOneTimeScore);

    const businessCreditServiceIds = [
        ezsServiceIds.businessCreditServiceBusinessCredit,
        ezsServiceIds.businessCreditServiceBusinessCreditPro,
        ezsServiceIds.businessCreditServiceBusinessCreditSelect,
    ];
    const isBusinessCreditService = useAreServicesActive(businessCreditServiceIds);
    const isCreditLockActive = useAreServicesActive([
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
    ]);
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );
    const retailerCode: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerCode
            ? state.configurationState.configuration.partnerConfig.retailerCode
            : ""
    );

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
            const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
            return partnerId != null && [2649, 1557].includes(partnerId);
        });

    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            let authStatus = state.creditAuthData.authData["auth-status"];
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                authenticated: authStatus ? authStatus.toUpperCase() : "NONE",
                message: state.creditAuthData.authData.message,
            };
        }
        return { isIDFUser: "", authenticated: "", message: "" };
    });

    const isBillingStatusLoaded: any = useSelector((state: ApplicationState) =>
        state.billingStatusState && state.billingStatusState.isBillingStatusLoaded ?
            state.billingStatusState.isBillingStatusLoaded : false
    );
    const isAdultFamilyMemberDetailsLoaded: any = useSelector((state: ApplicationState) =>
    state.familyServiceState && state.familyServiceState.isAdultFamilyMemberDetailsLoaded ?
        state.familyServiceState.isAdultFamilyMemberDetailsLoaded : false
    );

    const ensureDataFetched = () => {
        if (authData.authenticated === "AUTHENTICATED") {
            requestCreditAuth();
        }
        requestCreditHistory();

        if (isBusinessUser && isBusinessCreditService && creditProvider === "DUNBRADSTREET") {
            if (businessProfileStatus != null && businessProfileStatus.length > 0) {
                // if state hasn't already been set, call API and set state
                if (businessCreditReportStatePII.businessCompanyReport == null) {
                    services
                        .getBusinessCreditReport(null, businessProfileStatus[0].provider)
                        .then((data) => {
                            setBusinessCreditReportStatePII({ businessCompanyReport: data[0].businessCompanyReport });
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        }
    };

    const confirmUpgradeOrDowngrade = (showFamilyRenewPopup: Boolean, packageDetails?: any) => {
        document.body.classList.remove("no_scroll");
        setPayAsYouGoPkgDetails(packageDetails);
        if (showFamilyRenewPopup) {
            openRenewFamilyMemberDialog();
        } else {
            setUpgradeConfirmationDialog(true);
        }
    };

    const closeProtectionPlanDialog = () => {
        document.body.classList.remove("no_scroll");
        setUpgradeConfirmationDialog(false);
        services
            .PostContractChangeSucceed()
            .then((data) => {
                props.history.push("/redirect-to-url");
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const isAnyServiceActive = useCheckAnyServiceActive();

    const redirectTolastActivePage = () => {
        if (sessionStorage.getItem("sessionPath")) {
            history.push({ pathname: sessionStorage.getItem("sessionPath") || "/dashboard" });
            sessionStorage.removeItem("sessionPath");
        }
    };

    const getAuthenticationStatus = (email: any) => {
        services.getAuthenticationType({ email }).then((res) => {
            dispatch({
                type: RECEIVE_CONFIGURATION,
                configuration: {
                    ...appStateConfiguration,
                    userAuthStatus: res.userAuthStatus,
                },
            });
        });
    };

    useEffect(() => {
        if (breachServiceActive(breachService)) {
            if (sessionStorage.getItem("isActionByCategoryCalled")) {
                services.updateBreachAction({
                    ActionCategory: {
                        categoryList: ["SERVICE-ACTIVE-AUTO", "SERVICE-MONITOR-AUTO", "MOB-MAC-SVC-ACTIVE-ENABLED"],
                    },
                    serviceDetailsCache: null,
                    APICommonParameter: null,
                });
                sessionStorage.removeItem("isActionByCategoryCalled");
            }
        }
    }, [packageData, breachService]);

    useEffect(() => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        requesPartnerConfig();
        ensureDataFetched();

        if (!isCreditEnrollmentDetailsLoaded) {
            dispatch(CreditActions.actionCreators.getCreditEnrollmentDetails());
        }

        if (renderSiteInIFrame || renderInWebView) {
            redirectTolastActivePage();
        }
        dispatch(BreachActions.actionCreators.requestBreachService());
        if (!isBillingStatusLoaded) {
            dispatch(BillingStatusActions.actionCreators.getBillingStatus(true));
        }

        if (isIDFRevwireUser) {
            setShowWrittenInstructionDialog(true);
        }

        if (isLegacyIDFWrittenRequired) {
            setShowUltraSecureInstructionsDialog(true);
        } else {
            setShowUltraSecureInstructionsDialog(false);
        }

        if (isOneTrustPartner) {
            var cookiePrefIcon = document.getElementById('onetrust-consent-sdk');
            if (cookiePrefIcon != null) {
                cookiePrefIcon.hidden = true;
            }
        }
        if(!isAdultFamilyMemberDetailsLoaded){
            dispatch(FamilyServiceAction.actionCreators.getFamilyAdultMemberDetails(true));
        }
        sessionStorage.setItem('partnerPhoneNumber', partnerPhoneNumber);

    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (latestUserDashboardStatus !== "LoggedIn") {
            latestUserDashboardStatus = "RetailerDashboard";
        }
        if (latestUserDashboardStatus == "RetailerDashboard") {
            window.addToDataLayer({
                event: "RetailerDashboard",
                Retailercode: retailerCode,
                Package: {
                    packageCode: activePackageEnrollment?.packageCode,
                    packageName: activePackageEnrollment?.packageDisplayName,
                    packageType: activePackageEnrollment?.packageType,
                },
            });
        }
        dispatch(DashboardActions.actionCreators.setUserDashboardStatus("LoggedIn"));

    }, []);

    useEffect(() => {
        if (isPartnerModeSSO && emailAddress && appStateConfiguration && !appStateConfiguration.userAuthStatus) {
            getAuthenticationStatus(emailAddress);
        }
    }, [emailAddress]);

    useEffect(() => {
        if (
            changedServices != null &&
            changedServices.contractChangeData != null &&
            changedServices.contractChangeData.ContractStatus === "CANCELLATION_CHANGE_COMPLETE"
        ) {
            if (changedServices.cancellatinoContinuationData?.ServiceList != null && changedServices.cancellatinoContinuationData?.ServiceList.length > 0) {
                setShowCancelletionContinuation(true);
            }
        } else if (
            changedServices != null &&
            changedServices.contractChangeData != null &&
            (changedServices.contractChangeData.ContractStatus === "CHANGE" || changedServices.contractChangeData.ContractStatus === "CHANGE_COMPLETE")
        ) {
            setSubscriptionChangeDialog(true);
        }
    }, [changedServices]);

    useEffect(() => {
        let isNeedProfileCompletion =
            csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "authenticated" &&
            (csidUserStatus?.["dob-status"]?.toUpperCase() === "REQUIRED" || csidUserStatus?.["ssn-status"]?.toUpperCase() === "REQUIRED");
        if (isNeedProfileCompletion) {
            services.isTuCanadianUser().then((response) => {
                if (response && response.hasError === false && response.isCanadiaUser === false && isPrimaryAccount) {
                    setShowProfileCompleteDialog(true);
                }
            });
        }
    }, [csidUserStatus]);

    const isAuthenticated =
        csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "authenticated" ||
        csidUserStatus?.["auth-status"] === undefined ||
        csidUserStatus?.["auth-status"] === null;

        const [showBNPLBanner, setShowBNPLBanner] = useState(false);

        const isCountryUS = useSelector((state: ApplicationState) =>
            state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo?.country
                ? state.myAccountServiceState._unifiedAccountInfo.country === 'US'
                    ? true
                    : false
                : false
        );

        useEffect(() => {
            if (isCreditScoreOrTrackerActive && isCountryUS) {
                setShowBNPLBanner(true);
            }
            else{
                setShowBNPLBanner(false);
            }
        }, []);

        const closeBNPLBanner = (): any => {
            setShowBNPLBanner(false);
        };

    const getBannerMessage = (failedEnrollments) => {
        let failedBurau = '';
        if (failedEnrollments.length === 1) {
            failedBurau += failedEnrollments?.[0]?.bureauField;
        } else if (failedEnrollments.length === 2) {
            failedBurau += failedEnrollments?.[0]?.bureauField + ' and ' + failedEnrollments?.[1]?.bureauField;
        } else if (failedEnrollments.length === 3) {
            failedBurau += failedEnrollments?.[0]?.bureauField + ', ' + failedEnrollments?.[1]?.bureauField + ' and ' + failedEnrollments?.[2]?.bureauField;
        }
        const bannerMsg = <>
            {tLang("dashboard.creditEnrollmentBannerMsg1")}{" "}
            {failedBurau}{" "}
            {tLang("dashboard.creditEnrollmentBannerMsg2")}{" "}
            <span style={{ fontWeight: "600"}}>{tLang("dashboard.creditEnrollmentBannerMsg3")}</span>{" "}
            {tLang("dashboard.creditEnrollmentBannerMsg4")}{" "}
            {partnerPhoneNumber}.
        </>;
        return bannerMsg;
    };

    return (
        <React.Fragment>
            {!subscriptionChangeDialog && <TUAuthentication />}
            {isAuthenticated && showWrittenInstructionDialog && (
                <DialogComponent dialogId="dialog-written-instruction" title="Written Instruction" closeDialog={closeProfileCompleteDialog} hideCloseButton={true}>
                    <WrittenInstructionDialog onCloseCallback={closeWrittenInstructionDialog}></WrittenInstructionDialog>
                </DialogComponent>
            )}

            {isAuthenticated && showUltraSecureInstructionsDialog && (
                <DialogComponent dialogId="dialog-written-instruction" title="Written Instruction" closeDialog={closeProfileCompleteDialog} hideCloseButton={true}>
                    <WrittenInstructionDialog onCloseCallback={closeUltrasecureWrittenInstructionDialog} />
                </DialogComponent>
            )}
            {showPurchasePopup && (
                <DialogComponent dialogId="dialog-written-instruction" title="Written Instruction" closeDialog={closeProfileCompleteDialog} hideCloseButton={true}>
                    <MigratedUserPurchasePlan
                        dialogId="protection-plan-package-upgrade-dialog"
                        closeDialog={() => {
                            handlePackageUpgradeDialog("close");
                        }}
                        writtenInstructionTimeStamp={writtenInfoTime}
                        packageIndex={0}
                        closeUpgradeAndOpenCompletionDialog={""}
                    />
                </DialogComponent>
            )}
            {/*<!-- Page Title -->*/}

            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="dashboard-page" tabIndex={-1}>
                        {renderSiteInIFrame
                            ? "Hub"
                            : isAvastId || isAVGId || isAVGTestId
                                ? "Identity Protection Dashboard"
                                : isEsetId
                                    ? tLang("dashboard.overview")
                                    : tLang("dashboard.title")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            {/*<!-- Page Content -->*/}
            <div className={`${isActiveUserServicesLoaded === false ? "row loading" : "row"}`} id="content">
                {isAnyServiceActive && (
                    <div className="col-xs-12 col-sm-8">
                        {(csidUserStatus?.["auth-status"]?.toLowerCase() === "authenticated" && creditEnrollmentDetails?.failedEnrollments?.length > 0) && (
                            <div className="box d-flex flex-row">
                                <div className="col-10">
                                    <div className="sys-msg-content">
                                        <span className="error-icon">
                                            <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                            <p style={{ fontWeight: "600", display:"inline" }}>Important Notice!</p>
                                        </span>
                                        <p>
                                            {getBannerMessage(creditEnrollmentDetails.failedEnrollments)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        { showBNPLBanner && (
                            <div className="box d-flex flex-row">
                                <div className="col-10">
                                    <p><strong>Credit Report Information: </strong>
                                     TransUnion is now including some buy now, pay later (BNPL) installment loans on credit reports.&nbsp;
                                     <a className="default_link" target="_blank" href="https://www.transunion.com/Buy-Now-Pay-Later"> Learn More...</a>
                                    </p>
                                </div>
                                <div className="col-2" style={{marginLeft:"5px"}}>
                                    <span onClick={closeBNPLBanner} style={{cursor: "pointer"}}>
                                        <em className="las la la-close la-1x"></em>
                                    </span>
                                </div>
                            </div>
                        )}

                        {!refreshingCSIDUserStatus && (
                            <ErrorBoundary componentName="DashboardAlerts" type="hideError" replaceDefaultContent={false} errorMsg="">
                                <DashboardAlerts />
                            </ErrorBoundary>
                        )}

                        <ErrorBoundary componentName="Alert" type="hideError" replaceDefaultContent={false} errorMsg="">
                            <DashboardMessages />
                        </ErrorBoundary>

                        {!refreshingCSIDUserStatus && (
                            <ErrorBoundary componentName="LetsGetStarted" type="hideError" replaceDefaultContent={false} errorMsg="">
                                <LetsGetStarted
                                    history={props.history}
                                    openAddFamilyProtectionDialog={openAddFamilyProtectionDialog}
                                    openDashboardVideoDialog={openDashboardVideoDialog}
                                />
                            </ErrorBoundary>
                        )}

                        <DashboardService />

                        <ErrorBoundary componentName="CMServiceAuth" type="hideError" replaceDefaultContent={false} errorMsg="">
                            {!isCreditScoreOrTrackerActive && !refreshingCSIDUserStatus && <CMServiceAuth />}
                        </ErrorBoundary>

                        {breachServiceActive(breachService) ? (
                            <ErrorBoundary componentName="BreachIQCard" type="hideError" replaceDefaultContent={false} errorMsg="">
                                <BreachIQCard />
                            </ErrorBoundary>
                        ) : (
                            <></>
                        )}

                        {isCreditScoreOrTrackerActive && !refreshingCSIDUserStatus && <DashboardCredit history={props.history} />}

                        {isBusinessUser && isBusinessCreditService && <BusinessCredit />}

                        {isBusinessUser && isBusinessCreditService && (
                            <React.Fragment>
                                {creditProvider === "CREDITSAFE" && <BCreditScoreTracker showDetails={false} reportObject={[] as BusinessCreditReportStatePII} />}
                                {creditProvider === "DUNBRADSTREET" && (
                                    <React.Fragment>
                                        <BCreditRiskTracker
                                            reportObject={businessCreditReportStatePII}
                                            profileStatus={businessProfileStatus}
                                            showDetails={true}
                                            view={"dashboard"}
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}

                        {isAnyServiceActive && hasEducationAndBreach === true ? <EducationArticle /> : <></>}

                        {/* Download Mobile App */}
                        <ErrorBoundary componentName="DownloadApp" type="hideError" replaceDefaultContent={false} errorMsg="">
                            <DownloadApp showIcon={false} title={tLang("dashboard.downloadAppWidget.title")} isManageAccount={false} />
                        </ErrorBoundary>
                    </div>
                )}

                {isActiveUserServicesLoaded && isAnyServiceActive === false && (
                    <div className="col-xs-12 col-sm-8">
                        <div className="box-content" style={{ backgroundColor: "#FFF", width: "100%", padding: "30px" }}>
                            <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", width: "100%", padding: "10px" }}>
                                <div className="box-header col-xs-12 col-sm-12 ">
                                    <div className="content-sub-title text-align-center">
                                        <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                            <em className="las la-exclamation-circle "></em>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-content text-align-center">
                                    <p>{tLang("dashboard.noServiceActive.message")}</p>
                                    <p>
                                        <Link to="/manage-account/protection-plan" className="default_link">
                                            {tLang("dashboard.noServiceActive.protectionPlanLink")}
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Right side cards*/}
                {isAnyServiceActive && (
                    <div className="col-xs-12 col-sm-4">
                        <DedicatedResolutionSpecialistCard />

                        {isLostWallet && <LostWalletAssistance />}
                        {isRequestBreachCodesVisible() && <RequestBreachCodes />}
                        {isCreditLockActive && <CreditLockCard />}
                        {!isWhiteLabeled && <FeedbackCard authData />}
                    </div>
                )}
            </div>

            <ErrorBoundary componentName="subscription changed" type="hideError" replaceDefaultContent={false} errorMsg="">
                {subscriptionChangeDialog && (
                    <DialogComponent
                        dialogId="subscription-change-dialog"
                        title="Subscription Changed"
                        hideCloseButton={true}
                        closeDialog={() => {
                            handleSubscriptionChangeDialog("close");
                        }}
                    >
                        <SubscriptionChangeDialog
                            dialogId="subscription-change-dialog"
                            closeDialog={() => {
                                handleSubscriptionChangeDialog("close");
                            }}
                        ></SubscriptionChangeDialog>
                    </DialogComponent>
                )}
            </ErrorBoundary>

            <ErrorBoundary componentName="cancellation Continuation" type="hideError" replaceDefaultContent={false} errorMsg="">
                {showCancelletionContinuation && (
                    <DialogComponent
                        dialogId="cancellation-continuation-dialog"
                        title="Cancellation Continuation"
                        hideCloseButton={true}
                        closeDialog={() => {
                            handleCancellationContinuationDialog("close");
                        }}
                    >
                        <CancellationContinuationDialog
                            dialogId="cancellation-continuation-dialog"
                            closeDialog={() => {
                                handleCancellationContinuationDialog("close");
                            }}
                            onButtonClick={(showFamilyRenewDialog: Boolean, packageDetails?: any) => {
                                confirmUpgradeOrDowngrade(showFamilyRenewDialog, packageDetails);
                            }}
                            history={props.history}
                        ></CancellationContinuationDialog>
                    </DialogComponent>
                )}
            </ErrorBoundary>

            {upgradeConfirmationDialog && (
                <EZSProtectionPlanDialogContainer
                    initialDialog={"ProtectionPlanUpgradePackage"}
                    packageIndex={0}
                    onClose={closeProtectionPlanDialog}
                    subscriptionTypeChange={subscriptionTypeChange}
                    packageDetails={payAsYouGoPkgDetails}
                    removedFamilyMembers={removedFamilyMembers}
                    addedFamilyMembers={addedFamilyMembers}
                />
            )}

            {isRenewFamilyMemberDialogVisible && (
                <DialogComponent
                    dialogId="dialog-renew-family-member-account-dialog"
                    title="Renew Family Member"
                    closeDialog={(showUpgradePopup: boolean, removedFamilyMembers: any, addedFamilyMembers: any) =>
                        closeRenewFamilyMemberDialog(showUpgradePopup, removedFamilyMembers, addedFamilyMembers)
                    }
                >
                    <RenewFamilyMemberDialog
                        payAsYouGoPkgDetails={payAsYouGoPkgDetails}
                        closeDialog={(showUpgradePopup: boolean, removedFamilyMembers: any, addedFamilyMembers: any) =>
                            closeRenewFamilyMemberDialog(showUpgradePopup, removedFamilyMembers, addedFamilyMembers)
                        }
                        dialogId="dialog-renew-family-member-account-dialog"
                    />
                </DialogComponent>
            )}

            {isFamilyProtectionDialogVisible && (
                <DialogComponent dialogId="dialog-add-family-member-account-dialog" title="Add Family Member" closeDialog={closeFamilyProtectionDialog}>
                    <FamilyProtectionDialog closeDialog={closeFamilyProtectionDialog} />
                </DialogComponent>
            )}

            {showDashboardVideoDialog && (
                <DialogComponent hideCloseButton={true} dialogId="dialog-dashboard-video" title="Add Family Member" closeDialog={closeDashboardVideoDialog}>
                    <DashboardVideoDialog closeDialog={closeDashboardVideoDialog} dialogId="dialog-dashboard-video" />
                </DialogComponent>
            )}

            {showProfileCompleteDialog && (
                <DialogComponent dialogId="dialog-profile-completion" title="Profile Completiong" closeDialog={closeProfileCompleteDialog} hideCloseButton={false}>
                    <ProfileCompleteDialog onCloseCallback={closeProfileCompleteDialog}></ProfileCompleteDialog>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default Dashboard;
